const infos = [
    {   
        id:1,
        heading:"Problem in Face Matching",
        title:"Q. Face Not Matched! Try Again | Multiple Faces Detected!! Try Again | Face not matching | Facial data similar to Emp ID",
        content:{
            0:"1. Make sure your profile picture is covering your entire face. Click on Change Pic Button and Register Your Face ",
            1:"2. Make sure you have a valid network connection"
        }
    },
    {   
        id:2,
        heading:"Problem in Fetching Location",
        title:"Q. Problem In Fetching Location please try Again | Please turn on your GPS and allow Location permission | Geolocation is not supported by this browser",
        content:{
            0:"1. Click on Refresh Location Button of GATI App to refresh location.",
            1:"2. Make sure you have a valid network connecton.",
            2:"3. Close GATI app from the memory (through multitasking button/gesture on your phone) and reopen."
        }
    },
    {   
        id:3,
        heading:"Unable to Fetch Location",
        title:"Q. Error in Geolocation service | Unable to fetch location | Incorrect location | Failed to get locaiton",
        content:{
            0:"1. Make sure location service is enabled on your phone.",
            1:"2. Click on Refresh Location Button of GATI App to refresh location..",
            2:"3. LogOut from the app and close the app and remove the app from multi tasking"
        }
    },
    
]


export default infos